import { Checkbox, FormControlLabel } from '@mui/material';
import { Info } from '@mui/icons-material';
import { MobileTooltip } from 'components/MobileTooltip';
import { ChangeEvent } from 'react';
import { useUpgradeModal } from 'components/UpgradeModal';

interface Props {
  isPrivate?: boolean;
  onChange?: (arg: boolean) => void;
  disabled?: boolean;
}

export const PrivateCheckBox = ({
  isPrivate = false,
  onChange,
  disabled,
}: Props) => {
  const { showUpgradeModal } = useUpgradeModal();
  const change = (event: ChangeEvent<HTMLInputElement>) => {
    if (disabled) {
      showUpgradeModal('Upgrade to make your credits private.');
      event.preventDefault();
    } else if (onChange) onChange(event.target.checked);
  };
  const label = 'Make this credit private';
  const tooltip = 'If selected, only you and those credited will be able to see the credit. This will hide analytics related to the post from other viewers';
  return (
    <div>
      <FormControlLabel
        control={(
          <Checkbox
            checked={isPrivate}
            onChange={change}
            name="isCreditPrivate"
            color="primary"
          />
        )}
        label={label}
      />
      <MobileTooltip title={tooltip} arrow>
        <Info color="secondary" />
      </MobileTooltip>
    </div>
  );
};
